<template>
  <div class="union-flag" :style="{transform: `scale(${width / 236}) translateX(-50%)`}">
    <div class="flag-content"  ref="unionFlag">
      <div class="flag-bg">
        <div class="flag-left" v-html="bg"></div>
        <div class="flag-right" v-html="bg"></div>
      </div>
      <div class="flag-center">
        <div class="center-left" v-html="edgings"></div>
        <div class="center-right" v-html="edgings"></div>
      </div>
      <div class="flag-icon" v-html="pattern"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UnionFlag",
  data() {
    return {
      imgBaseUrl:
        "https://res-zs-studio.gtarcade.com/product-408/cdn1/GTA/h5/flag-assets/",
      bg: '',
      edgings: '',
      pattern: '',
      bgHash: {
        1: 'G_0001.png',
        2: 'G_0002.png',
        3: 'R_0001.png',
        4: 'R_0002.png',
        5: 'B_0001.png',
        6: 'B_0002.png',
        7: 'G_0003.png',
        8: 'G_0004.png',
        9: 'G_0005.png',
        10: 'G_0006.png',
        11: 'R_0003.png',
        12: 'R_0004.png',
        13: 'R_0005.png',
        14: 'R_0006.png',
        15: 'B_0003.png',
        16: 'B_0004.png',
        17: 'B_0005.png',
        18: 'B_0006.png',
      },
      edgingsHash: {
        1: 'DW_001.png',
        2: 'DW_002.png',
        3: 'DW_003.png',
        4: 'DW_004.png',
        5: 'DW_005.png',
        6: 'DW_006.png',
        7: 'DW_007.png',
        8: 'DW_008.png',
      },
      patternHash: {
        1: 'L_0001.png',
        2: 'L_0002.png',
        3: 'L_0003.png',
        4: 'L_0004.png',
        5: 'L_0005.png',
        6: 'L_0006.png',
        7: 'L_0007.png',
        8: 'L_0008.png',
        9: 'L_0009.png',
      },
    };
  },
  props: {
    width: [Number, String],
    flagStyle: {
      type: Object,
      default() {
        return {
          bg: "", //样式ID
          edgings: "", //边条ID
          pattern: "", //图案ID
        };
      },
    },
  },
  watch: {
    flagStyle: {
      handler() {
        this.init()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    init() {
      let loadedCount = 0
      this.$nextTick(() => {
        this.$Spinner.showLoading(this.$refs.unionFlag)
      })
      let imgArr = Object.keys(this.flagStyle)
      imgArr.forEach(i => {
       this.flagStyle[i] && this.loadImage(`${this.imgBaseUrl}${this[i + 'Hash'][this.flagStyle[i]]}`, (img) => {
          this[i] = img.outerHTML
          loadedCount++
          if (loadedCount == imgArr.length) {
            this.$Spinner.hideLoading(this.$refs.unionFlag)
          }
        })
      })
    },
    loadImage(url, callback) {     
      var img = new Image() //创建一个Image对象，实现图片的预下载     
      img.src = url
        
      img.onload = function () { //图片下载完毕时异步调用callback函数
        img.onload = null
        callback(img)
        img.src = url; 
      }
    }
  }
}
</script>

<style lang="scss">
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>

<style lang="scss" scoped>
.union-flag {
  position: absolute;
  // w: 236px  h: 256
  width: 2.36rem;
  height: 2.56rem;
  left: 50%;
  top: 0;
  bottom: 0;
  margin: auto;
  transform-origin: left;

  .flag-content {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .flag-bg {
    width: 100%;
    height: 100%;
    height: fit-content;
    font-size: 0;

    .flag-left,
    .flag-right {
      width: 50%;
      height: 100%;
      float: left;
    }

    .flag-right {
      transform-origin: center;
      transform: scale(-1, 1);
    }
  }

  .flag-center {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    margin: auto;
    width: 1.76rem;
    height: 2.1rem;

    .center-left,
    .center-right {
      width: 50%;
      height: 100%;
      float: left;
    }

    .center-right {
      transform-origin: center;
      transform: scale(-1, 1);
    }
  }

  .flag-icon {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    margin: auto;
    width: 1.92rem;
    height: 1.92rem;
  }
}
</style>